import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const NAV_LINKS = [{
  label: 'Home',
  href: 'https://www.lakegeorgeboating.com/',
  active: false
}, {
  label: 'Marina Services',
  href: 'https://www.lakegeorgeboating.com/marina-services',
  active: false
}, {
  label: 'Pre-Owned Boats',
  href: '#',
  active: true
}, {
  label: 'Contact',
  href: 'https://www.lakegeorgeboating.com/contact',
  active: false
}];
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <header className="w-full bg-white border-b border-cream sticky top-0 z-50" data-id="element-58">
      <div className="py-4 px-6 md:px-12 flex justify-between items-center" data-id="element-59">
        <div className="flex items-center" data-id="element-60">
          <img src="https://cdn.magicpatterns.com/uploads/uRbkKVm2QnsBqNb5EX25cD/Queen_co_boat_company_logo.png" alt="Queen Boat Co." className="h-16 object-contain" data-id="element-61" />
        </div>
        <nav className="hidden md:flex space-x-8 text-navy font-medium" data-id="element-62">
          {NAV_LINKS.map(link => <a key={link.label} href={link.href} className={link.active ? 'text-copper border-b-2 border-copper pb-1' : 'hover:text-copper transition-colors'} data-id="element-63">
              {link.label}
            </a>)}
        </nav>
        <div className="md:hidden flex items-center" data-id="element-64">
          <button type="button" onClick={() => setMenuOpen(open => !open)} className="text-navy" aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'} aria-expanded={menuOpen} aria-controls="mobile-nav" data-id="element-65">
            {menuOpen ? <XIcon className="h-6 w-6" data-id="element-66" /> : <MenuIcon className="h-6 w-6" data-id="element-67" />}
          </button>
        </div>
      </div>

      {menuOpen && <nav id="mobile-nav" className="md:hidden border-t border-cream bg-white px-6 py-4 flex flex-col space-y-1 text-navy font-medium" data-id="element-68">
          {NAV_LINKS.map(link => <a key={link.label} href={link.href} onClick={() => setMenuOpen(false)} className={link.active ? 'py-2 text-copper font-semibold' : 'py-2 hover:text-copper transition-colors'} data-id="element-69">
              {link.label}
            </a>)}
        </nav>}
    </header>;
}